import React from "react";
import { Route } from "react-router-dom";
import AuthGuard from "../pages/SHARED/Utilities/AuthGuard";
import RequireSuperUser from "../pages/SHARED/Utilities/RequireSuperUser";

import AdminHome from "../pages/Internal User/Admin User/Home";
import AdminAccountManagement from "../pages/Internal User/Admin User/AccountManagement";
import AdminDataManagement from "../pages/Internal User/Admin User/DataManagement";
import AdminSystemManagement from "../pages/Internal User/Admin User/SystemManagement";
import Analytics from "../pages/Internal User/Admin User/Analytics";
import ManuallySignedIndemnities from "../pages/Internal User/Admin User/ManuallySignedIndemnities";
import SupportRequestsLog from "../pages/admin/SupportRequestsLog";
import DuplicateAccountsHome from "../pages/Internal User/Shared Management Pages/Account Duplicates/DuplicateAccountsHome";

const G = (children) => <AuthGuard>{children}</AuthGuard>;

const adminRoutes = [
  <Route key="admin-home" path="/admin_home" element={G(<AdminHome />)} />,
  <Route
    key="duplicate-accounts"
    path="/vermost_duplicate_accounts"
    element={G(<RequireSuperUser><DuplicateAccountsHome /></RequireSuperUser>)}
  />,
  <Route key="admin-account" path="/admin_account_management" element={G(<AdminAccountManagement />)} />,
  <Route key="admin-data" path="/admin_data_management" element={G(<AdminDataManagement />)} />,
  <Route key="admin-system" path="/admin_system_management" element={G(<AdminSystemManagement />)} />,
  <Route key="admin-analytics" path="/analytics" element={G(<Analytics />)} />,
  <Route key="admin-indemnities" path="/vermost_manually_signed_indemnities" element={G(<ManuallySignedIndemnities />)} />,
  <Route key="admin-support" path="/admin/support-requests" element={G(<SupportRequestsLog />)} />,
];

export default adminRoutes;
